module.exports = {"cookies":"Cookie","help":"帮助","privacy":"隐私","signInButtonText":"使用 Adobe ID 登录","termsOfUse":"使用条款","updated":"已更新"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/zh_cn.json
// module id = 951
// module chunks = 0